const options = {
  5: "bg-lime-800/5",
  10: "bg-lime-800/10",
  25: "bg-lime-800/25",
  50: "bg-lime-800/50",
  75: "bg-lime-800/75",
  90: "bg-lime-800/90",
  100: "bg-lime-800",
};

const from = {
  5: "from-lime-800/5",
  10: "from-lime-800/10",
  25: "from-lime-800/25",
  50: "from-lime-800/50",
  75: "from-lime-800/75",
  90: "from-lime-800/90",
  100: "from-lime-800",
};

export default function getBackgroundLime800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
